import React from 'react';
import PropTypes from 'prop-types';

import Utils from '../../../Services/Utils';

import InputWrapper from '../WrapperInput';
import Icon from '../../Common/Icon';
import withShallowComparison from '../../Common/withShallowComparisonUpdate';

import './style.scss';
import {ReactComponent as StarActiveIcon} from "../../../../img/icon-star-score.svg";
import {ReactComponent as StarIcon} from "../../../../img/icon-star-score-disable.svg";

class InputStars extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      scoreAux: !Utils.isNull(this.props.value) ? this.props.value : undefined,
      score: !Utils.isNull(this.props.value) ? this.props.value : undefined
    };
  }

  componentDidMount() {
    this.initValidate();
  }

  componentDidUpdate() {
    this.initValidate();
  }

  initValidate = () => {
    const { value, onError, error } = this.props;
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  }

  setScoreAux = (score, setScore) => {
    const { disabled } = this.props;
    if (disabled) return;
    if (setScore) {
      this.setState({
        scoreAux: !Utils.isNull(score) ? score : undefined,
        score: !Utils.isNull(score) ? score : undefined,
      });
    }
    else {
      this.setState({
        scoreAux: !Utils.isNull(score) ? score : undefined,
      });
    }
  };

  validate = (value) => {
    const { required, validators } = this.props;
    if (required && Utils.isNull(value)) return 'This field is required.';
    for (const validator of validators || []) {
      if (validator(value)) return validator(value);
    }
    return '';
  };

  handleChange = (value) => {
    const {onChange, onError, error, disabled} = this.props;
    if (disabled) return;
    const val = this.props.value === value ? null : value;
    this.setScoreAux(val, true);
    if (onChange) onChange(val);
    const newError = this.validate(val);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  };

  render() {
    const {
      className,
      label,
      labelhtml,
      error,
      stars,
      disabled,
      required,
      value,
    } = this.props;

    const WrapperProps = {
      className,
      label,
      labelhtml,
      error,
      required,
    };

    const { scoreAux } = this.state;

    const numberStars = stars ? Array.from(Array(Math.abs(parseInt(stars))).keys()) : Array.from(Array(10).keys());

    const newValue = !Utils.isNull(value) ? value : undefined;

    return (
      <InputWrapper { ...WrapperProps }>
        <div className='WrapperStars Pointer Clearfix'
             onMouseLeave={ () => this.setScoreAux(value) }>
          { numberStars.map((item, index) => (
            <Icon
              key={ index }
              width='15'
              height='15'
              color='primaryColor'
              onClick={ () => this.handleChange((index+1)) }
              onMouseOver={ () => this.setScoreAux((index+1)) }>
              { (scoreAux >= (index+1)) &&
                <StarActiveIcon alt='icon-star-score'/>
                ||
                <StarIcon alt='icon-star-score-disable'/>
              }
            </Icon>
          ))}
        </div>
        <input
          defaultValue={ !Utils.isNull(newValue) ? newValue : '' }
          disabled={ disabled }
          required={ required }
          hidden={true}
        />
      </InputWrapper>
    );
  }
}

InputStars.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  stars: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  error: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onError: PropTypes.func,
};

export default withShallowComparison(InputStars, ['onChange', 'onError']);
